import COLORS from './colors';

const LIGHT_COLORS = Object.freeze({
  primary0: COLORS.azureWeb,
  primary100: COLORS.celeste,
  primary200: COLORS.tiffanyBlue,
  primary300: COLORS.turquoise,
  primary400: COLORS.strongTurquoise,
  primary500: COLORS.keppel,
  primary600: COLORS.persianGreen,
  primary700: COLORS.pineGreen,
  primary800: COLORS.brunswickGreen,
  primary900: COLORS.richBlack,

  neutral0: COLORS.whiteSmoke,
  neutral100: COLORS.platinum,
  neutral200: COLORS.silver,
  neutral300: COLORS.shinySilver,
  neutral400: COLORS.battleShipGray,
  neutral500: COLORS.dimGray,
  neutral600: COLORS.davyGray,
  neutral700: COLORS.onyx,
  neutral800: COLORS.eerieBlack,
  neutral900: COLORS.night,

  success0: COLORS.honeydew,
  success100: COLORS.celadon,
  success200: COLORS.lightGreen,
  success300: COLORS.malachite,
  success400: COLORS.sgbusGreen,
  success500: COLORS.limeGreen,
  success600: COLORS.forestGreen,
  success700: COLORS.officeGreen,
  success800: COLORS.pakistanGreen,
  success900: COLORS.nightGreen,

  warning0: COLORS.floralWhite,
  warning100: COLORS.dutchWhite,
  warning200: COLORS.peachYellow,
  warning300: COLORS.metallicGold,
  warning400: COLORS.gold,
  warning500: COLORS.satinGold,
  warning600: COLORS.goldenBrown,
  warning700: COLORS.fieldDrab,
  warning800: COLORS.drabDarkBrown,
  warning900: COLORS.smokeyBlack,

  danger0: COLORS.lavendarBlush,
  danger100: COLORS.orchidPink,
  danger200: COLORS.amaranthPink,
  danger300: COLORS.blush,
  danger400: COLORS.cerise,
  danger500: COLORS.roseRed,
  danger600: COLORS.claret,
  danger700: COLORS.darkClaret,
  danger800: COLORS.chocolateCosmos,
  danger900: COLORS.licorice,

  textPrimaryWhite: COLORS.white,
  textSecondaryWhite: COLORS.whiteLowTransparent,
  textTertiaryWhite: COLORS.whiteHighTransparent,

  textPrimaryBlack: COLORS.black,
  textSecondaryBlack: COLORS.blackLowTransparent,
  textTertiaryBlack: COLORS.blackHighTransparent,
});

export default LIGHT_COLORS;
